export default __webpack_public_path__ + "static/media/onlineeducation.4ac51594.jpg";